/*@ngInject*/
module.exports = function (publicObjectsService, data, $uibModalInstance) {
    const vm = this;

    vm.object = data.object;
    vm.objectType = data.objectType;

    vm.suggestionForm = {};
    vm.suggestion = {};
    vm.showErrors = false;
    vm.modalInstace = $uibModalInstance;

    vm.submitSuggestion = () => {
        vm.showErrors = true;
        if(vm.suggestionForm.$invalid) {
            return false;
        }
        publicObjectsService.addSuggestion(vm.suggestion, vm.object.id, vm.objectType).then((result) => {
            vm.modalInstace.close(result.data);
        });
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/suggestions/object-suggestion-modal.directive.js
 **/